import PassengerType from "@CheckOrder/types/Passenger.type";
import usePrepareAdditionalInfoForPassengerSubmit
    from "@CheckOrder/features/TicketAdditionalInfo/functions/usePrepareAdditionalInfoForPassengerSubmit";
import {useLazyUpdatePassengerGroupQuery} from "@CheckOrder/api/checkOrderApi";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Updates passenger values to redux, server authoritative
 */
interface UpdatePassengerGroupAttributes {
    passenger: PassengerType,
    passengerIndex: number,
    passengerGroup: number,
    tripType: 'single' | 'return',
    updateBothTripSegments: boolean /* passenger number in array */
}

export default function useUpdatePassengerGroup(props: UpdatePassengerGroupAttributes) {
    const {prepareAdditionalInfo} = usePrepareAdditionalInfoForPassengerSubmit()
    const {passengers, ticket} = useAppSelector((state) => state?.checkOrder)
    const [updatePassengerGroupQuery] = useLazyUpdatePassengerGroupQuery()

    const {
        passenger,
        passengerIndex,
        passengerGroup,
        tripType,
        updateBothTripSegments,
    } = props

    const updatePassengerGroup = () => {
        const group = tripType === 'single' ? 'singlePassengerGroupId' : 'returnPassengerGroupId'
        const newPassenger = {
            ticketCode: ticket.ticketCode,
            ...passenger,
            // We only care about the name, ignore the ISO and dial code
            additionalInfo: prepareAdditionalInfo(passenger.additionalInfo),
            nationality: passenger?.nationality?.name ?? passenger?.nationality,
            [group]: passengerGroup,
        };

        if (ticket.isReturn && tripType === 'return' && updateBothTripSegments) {
            // Updates both groups if company is same and has same groups
            newPassenger.returnPassengerGroupId = passengerGroup;
        }

        updatePassengerGroupQuery({
            passenger: newPassenger,
            passengerIndex,
            passengers,
        })
    }

    return {
        updatePassengerGroup,
    }
}